/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InspectionCategoryTypeResponse
 */
export interface InspectionCategoryTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof InspectionCategoryTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionCategoryTypeResponse
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof InspectionCategoryTypeResponse
     */
    inspectionId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionCategoryTypeResponse
     */
    categoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionCategoryTypeResponse
     */
    typeId?: number;
}

/**
 * Check if a given object implements the InspectionCategoryTypeResponse interface.
 */
export function instanceOfInspectionCategoryTypeResponse(value: object): value is InspectionCategoryTypeResponse {
    return true;
}

export function InspectionCategoryTypeResponseFromJSON(json: any): InspectionCategoryTypeResponse {
    return InspectionCategoryTypeResponseFromJSONTyped(json, false);
}

export function InspectionCategoryTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionCategoryTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'inspectionId': json['inspectionId'] == null ? undefined : json['inspectionId'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'typeId': json['typeId'] == null ? undefined : json['typeId'],
    };
}

export function InspectionCategoryTypeResponseToJSON(json: any): InspectionCategoryTypeResponse {
    return InspectionCategoryTypeResponseToJSONTyped(json, false);
}

export function InspectionCategoryTypeResponseToJSONTyped(value?: InspectionCategoryTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'inspectionId': value['inspectionId'],
        'categoryId': value['categoryId'],
        'typeId': value['typeId'],
    };
}

